export default "__VITE_ASSET__CgpWa3La__"